import axios from "axios";

export const state = {
    users: [],
};

export const getters = {
    users: state => state.users,
};

export const mutations = {
    setUsers(state, newValue) {
        state.users = newValue
    },
};

export const actions = {
    fetchUsers({ commit }) {
        axios.get('/systemusers').then(res => {
            commit('setUsers', res.data.users)
        })
    },
};
